/***
 * Model that represents an Agent Device.
 */
import Backbone from 'backbone';

var AgentDevice = Backbone.Model.extend({
    initialize: function(args) {
        this.isDirty = false;
        this.bind('change', this.onChange, this);
        this.bind('sync', this.onSync, this);
    },

    /**
     * Function that can be used to store the current state of the models attributes.
     */
    backup: function() {
        this.backupAttributes = _.clone(this.attributes);
    },

    restore: function() {
        if (this.backupAttributes) {
            this.set(this.backupAttributes);
            this.isDirty = false;
        }
    },

    onSync: function() {
        this.isDirty = false;
        this.backup();
    },

    onChange: function() {
        this.isDirty = true;
    }
});

export default AgentDevice;
